export default __webpack_public_path__ + "static/media/platformFeatures.24dced9c.png";